var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "base container-fluid" },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "d-flex justify-center align-center pa-8" },
            [
              _c("v-progress-circular", {
                attrs: { size: 35, color: "primary", indeterminate: "" }
              })
            ],
            1
          )
        : _vm._e(),
      !_vm.index ? _c("VisaoGeral") : _vm._e(),
      _vm.index
        ? _c("RentabilidadeAnual", {
            attrs: { ativos: _vm.wallet, calculos: _vm.calculos }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }